import React from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";

interface ColorPowersProp {
  left_boxes?: number | any;
  right_boxes?: number | any;
  item_image?: string;
  variant_title?: string;
  left_sph?: string;
  right_sph?: string;
  price?: string | any;
  temp_cart_id?: number | any;
  cart_id: number | any;
  right?: boolean | any;
  left?: boolean | any;
  power_type?:string
  compare_at_price?:string | any;

}

export const ColorPowers = (props: ColorPowersProp) => {
  const { updateCartItem } = useShoppingCart();
  let quantity = 0;
  // let left = {};
  // let right = {};
  if (
    props.left_boxes === undefined ||
    props.left_boxes === null
  ) {
    quantity = parseInt(props.right_boxes);
  } else if (
    props.right_boxes === undefined ||
    props.right_boxes === null
  ) {
    quantity = parseInt(props.left_boxes);
  } else {
    quantity = parseInt(props.left_boxes) + parseInt(props.right_boxes);
  }

  const increaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes) + 1,
          sph: props.left_sph,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes),
          sph: props.right_sph,
        },
      }),
    },
  };

  const decreaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes) - 1,
          sph: props.left_sph,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes),
          sph: props.right_sph,
        },
      }),
    },
  };

  const increaseQuantityRight = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes),
          sph: props.left_sph,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes) + 1,
          sph: props.right_sph,
        },
      }),
    },
  };

  const decreaseQuantityRight = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes),
          sph: props.left_sph,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes) - 1,
          sph: props.right_sph,
        },
      }),
    },
  };

  return (
    <>
      <div className="powerWrappers">
        {props.left_sph && (
          <div className="leftPowerWrapper">
            <div className="quantityItem">
              <div className="eyeSpecs">
                <span className="eyeHeading">Left Eye : </span>
                <span className="quantityCount">
                  <button
                    onClick={
                      parseInt(props.left_boxes) > 1
                        ? () => updateCartItem(decreaseQuantityLeft)
                        : undefined
                    }
                  >
                    -
                  </button>
                  {parseInt(props.left_boxes)}
                  <button onClick={() => updateCartItem(increaseQuantityLeft)}>
                    +
                  </button>
                </span>
              </div>
              <div className="itemPrice">
               
                {/* <span className="itemPriceCompare">Rs. 300 </span> */}
              <span className="itemPriceCompare">Rs. {props.compare_at_price * parseInt(props.left_boxes)} </span>
              <span className="itemPriceSelling">Rs. {props.price * parseInt(props.left_boxes)}</span>
              </div>
            </div>

            <div className="leftPowers powersData">
              <span className="powersHeading">SPH:</span>{" "}
              <span className="powers">{props.left_sph}</span>
            </div>
          </div>
        )}
        {props.right_sph && (
          <div className="rightPowerWrapper">
            <div className="quantityItem">
              <div className="eyeSpecs ">
                <span className="eyeHeading">Right Eye : </span>
                <span className="quantityCount">
                  <button
                    onClick={
                      parseInt(props.right_boxes) > 1
                        ? () => updateCartItem(decreaseQuantityRight)
                        : undefined
                    }
                  >
                    -
                  </button>
                  {parseInt(props.right_boxes)}
                  <button onClick={() => updateCartItem(increaseQuantityRight)}>
                    +
                  </button>
                </span>
              </div>
              <div className="itemPrice">
              {/* <span className="itemPriceCompare">Rs. 300 </span> */}
              <span className="itemPriceCompare">Rs. {props.compare_at_price * parseInt(props.right_boxes)} </span>
              <span className="itemPriceSelling">Rs. {props.price * parseInt(props.right_boxes)}</span>
                
              </div>
            </div>
            <div className="rightPowers powersData">
              <span className="powersHeading">SPH:</span>{" "}
              <span className="powers">{props.right_sph}</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
